






















































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common";
import jsZip from "jszip";
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import SaitenBox from "../../components/SaitenBox.vue";
import TextEditBox from "../../components/TextEditBox.vue";
import VSwatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.css";
import PreviewImageSidebar from "../../components/PreviewImageSidebar.vue";
import { BModal, BPopover } from 'bootstrap-vue';
import { SplitterComponent, PanesDirective, PaneDirective, ResizingEventArgs } from "@syncfusion/ej2-vue-layouts"
import { Sheet, SheetField, FieldActivity, ParamFieldActivity, SaitenModeEnum, CorrectStateEnum, SortKindEnum, DirectionEnum, TensakuText, Point } from "../../modules/teacher/SaitenInput";

export interface Data {
  sheet_id: string
  sheet_field_id: string
  next_room_sheet_id: number | null
  next_room_sheet_field: SheetField | null
  prev_room_sheet_id: number | null
  prev_room_sheet_field: SheetField | null
  prev_sheet_field: SheetField | null
  next_sheet_field: SheetField | null
  currentSheet: Sheet | null
  currentSheetField: SheetField | null
  fieldActivities: FieldActivity[]
  selectedIdx: number
  colCount: number
  scale: number
  fieldPadding: number
  fieldMargin: number
  fieldWrapWidth: number
  fieldWrapHeight: number
  fieldImageWidth: number
  fieldImageHeight: number
  windowHeight: number
  SaitenModeEnum: Readonly<{None: number; KeyInput: number; SeitouClick: number; GotouClick: number; TokutenClick: number; 
                            FreeLine: number; StraightLine: number; BracesStart: number; BracesEnd: number; Number: number; Eraser: number;}>
  CorrectStateEnum: Readonly<{Seitou: number; Gotou: number; Tokuten: number}>
  SortKindEnum: Readonly<{No: number; CorrectState: number; FileSize: number}>
  SheetTypeEnum: Readonly<{Normal: number; Cbt: number; Entrance: number; Practice: number;}>
  saitenMode: number
  sortKind: number
  scoreOptions: any[]
  selectedScore: number
  isTokutenModeDisabled: boolean
  processingTime: number
  base64CorrectImage: string
  thickness: number
  isColCountChanged: boolean
  isWindowEventAdded: boolean
  allowResetSaitenLock: boolean
  isProcessingApi: boolean
  isUpdateConfirmed: boolean
  pcHelpFields: any[]
  tabletHelpFields: any[]
  timer: any
  keyCode: string
  errors: string[]
  drawColor: string
  DirectionEnum: Readonly<{Horizon: number; Vertical: number;}>
  direction: number
  mainAreaWidth: number
  mainAreaHeight: number
  horizonTopHeightPer: number
  horizonBottomHeightPer: number
  verticalLeftWidthPer: number
  verticalRightWidthPer: number
  separatorSize: number
  isDispCorrectImage: boolean
  correctImageScale: number
  scrollBarSize: number
  correctImageMarginTop: number
  isLoaded: boolean
  examineeIds: number[]
  isScanImageVisible: boolean
  previewScanImageExamineeId: number
  is_first_room: boolean
  is_last_room: boolean
  isSortAsc: boolean
  fontSize: number
  lineHeight: number
  textColor: string
  selectedTensakuText: TensakuText
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "saiten-box": SaitenBox,
    "text-edit-box": TextEditBox,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
    "preview-image-sidebar": PreviewImageSidebar,
    "v-swatches": VSwatches,
  },
  setup(_, context){

    const saitenBoxRef = ref([]);
    const modalAddtionRef = ref<InstanceType<typeof BModal>>();
    const modalPcHelpRef = ref<InstanceType<typeof BModal>>();
    const modalTabletHelpRef = ref<InstanceType<typeof BModal>>();
    const previewImageSidebarRef = ref<InstanceType<typeof PreviewImageSidebar>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet_field_id: "",
      next_room_sheet_id: null,
      next_room_sheet_field: null,
      prev_room_sheet_id: null,
      prev_room_sheet_field: null,
      prev_sheet_field: null,
      next_sheet_field: null,
      currentSheet: null,
      currentSheetField: null,
      fieldActivities: null,
      selectedIdx: 0,
      colCount: 0,
      scale: 0,
      fieldPadding: 8,
      fieldMargin: 5,
      fieldWrapWidth: 0,
      fieldWrapHeight: 0,
      fieldImageWidth: 0,
      fieldImageHeight: 0,
      windowHeight: 0,
      SaitenModeEnum: SaitenModeEnum,
      CorrectStateEnum: CorrectStateEnum,
      SortKindEnum: SortKindEnum,
      SheetTypeEnum: Common.SheetTypeEnum,
      saitenMode: SaitenModeEnum.KeyInput,
      sortKind: SortKindEnum.No,
      scoreOptions: new Array<object>(),
      selectedScore: 0,
      isTokutenModeDisabled: false,
      processingTime: 0,
      base64CorrectImage: "",
      thickness: 2,
      isColCountChanged: false,
      isWindowEventAdded: false,
      isUpdateConfirmed: false,
      allowResetSaitenLock: true,
      isProcessingApi: false,
      pcHelpFields: [
        { key: "O・Aキー", img: [require("@/assets/images/keyboard_A.png"), require("@/assets/images/keyboard_O.png")], description: "正答○（KEY入力モードのみ有効）" },
        { key: "X・Fキー", img: [require("@/assets/images/keyboard_F.png"), require("@/assets/images/keyboard_X.png")], description: "誤答✕（KEY入力モードのみ有効）" },
        { key: "1-9キー", img: [require("@/assets/images/keyboard_1.png")], description: "△得点（KEY入力モードのみ有効）" },
        { key: "Pキー", img: [require("@/assets/images/keyboard_P.png")], description: "一括正答（未採点分をすべて○）" },
        { key: "Zキー", img: [require("@/assets/images/keyboard_Z.png")], description: "一括誤答（未採点分をすべて✕）" },
        { key: "BackSpaceキー", img: [require("@/assets/images/keyboard_Backspace.png")], description: "選択中の切出しの採点内容をクリア" },
        { key: "テキスト選択中にBackSpaceキー", img: [require("@/assets/images/keyboard_Backspace.png")], description: "選択中のテキストを削除" },
        { key: "エンターキー", img: [require("@/assets/images/keyboard_Enter.png")], description: "採点内容を保存して次の設問へ、または次の教室へ移動" },
        { key: "Mキー", img: [require("@/assets/images/keyboard_M.png")], description: "採点内容を保存して次の設問へ移動" },
        { key: "Nキー", img: [require("@/assets/images/keyboard_N.png")], description: "採点内容を保存して次の教室へ移動" },
        { key: "Hキー", img: [require("@/assets/images/keyboard_H.png")], description: "保存して戻る" },
        { key: "Wキー", img: [require("@/assets/images/keyboard_W.png")], description: "模範解答画像を表示" },
        { key: "Gキー", img: [require("@/assets/images/keyboard_G.png")], description: "拡大" },
        { key: "Qキー", img: [require("@/assets/images/keyboard_Q.png")], description: "縮小" },
        { key: "矢印キー", img: [require("@/assets/images/keyboard_Arrow.png")], description: "矢印の方向の切出し画像へ選択を変更" },
        { key: "Dキー + マウス", img: [require("@/assets/images/keyboard_D.png")], description: "自由線" },
        { key: "Eキー + マウス", img: [require("@/assets/images/keyboard_E.png")], description: "消しゴム" },
        { key: "Tキー + マウス", img: [require("@/assets/images/keyboard_T.png")], description: "テキスト" },
      ],
      tabletHelpFields: [
        { key: "右方向", img: require("@/assets/images/flick_right.png"), description: "正答○" },
        { key: "左方向", img: require("@/assets/images/flick_left.png"), description: "誤答✕" },
        { key: "下方向", img: require("@/assets/images/flick_down.png"), description: "△の横の得点" },
        { key: "画像上を長押し", img: null, description: "長押しした箇所にテキストを表示" },
        { key: "テキストを長押し", img: null, description: "テキストを削除" },
        { key: "", img: [require("@/assets/images/keyboard_SaitenInputModeArea.png")], description: "KEY入力モード以外のメニューボタンがON（緑色）になっている場合は、<font style='color:red'>長押し操作が反映されません。</font><br>ON（緑色）のアイコンを押すと、OFF（グレー）に戻ります。" },
      ],
      timer: null,
      keyCode: "",
      errors: [],
      drawColor: "#FF0000",
      DirectionEnum: DirectionEnum,
      direction: DirectionEnum.Horizon,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      horizonTopHeightPer: 0.3,
      horizonBottomHeightPer: 0.7,
      verticalLeftWidthPer: 0.2,
      verticalRightWidthPer: 0.8,
      separatorSize: 10,
      isDispCorrectImage: true,
      correctImageScale: 50,
      scrollBarSize: 0,
      correctImageMarginTop: 15,
      isLoaded: false,
      examineeIds: [],
      isScanImageVisible: false,
      previewScanImageExamineeId: null,
      is_first_room: false,
      is_last_room: false,
      isSortAsc: true,
      fontSize: 20,
      lineHeight: 0,
      textColor: "#FF0000",
      selectedTensakuText: null,
    });

    /************************************************************
     * 選択中のテキスト要素のID
     ************************************************************/

    const selectedTensakuTextElemId = computed((): any => {
      if(!state.selectedTensakuText || state.selectedIdx == null){
        return null;
      }else{
        return `saiten-box-${state.selectedIdx}-${state.direction}`;
        // return `text-image-${state.direction}-${state.fieldActivities[state.selectedIdx].id}-${state.selectedTensakuText.idx}`;
      }
    });

    /************************************************************
     * 選択中のテキストスタンプ切り替え SaitenBoxから呼ばれる
     ************************************************************/

    const changeSelectedTensakuText = (tensakuText: TensakuText) => {
      state.selectedTensakuText = tensakuText;
      if(state.selectedTensakuText){
        state.fontSize = tensakuText.font_size;
        state.lineHeight = tensakuText.line_height;
        state.textColor = tensakuText.color;
      }
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeText = () => {
      const size = Common.getTextSize(state.selectedTensakuText.text, state.selectedTensakuText.font_size, state.selectedTensakuText.line_height);
      state.selectedTensakuText.width = size.width;
      state.selectedTensakuText.height = size.height;
      state.selectedTensakuText.base64_text = Common.createBase64Text(state.selectedTensakuText);
      state.fieldActivities[state.selectedIdx].isTextEdited = true;
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ・行間変更後イベント
     ************************************************************/

    const textFormatChanged = (fontSize: number, lineHeight: number, textColor: string) => {
      state.fontSize = fontSize;
      state.lineHeight = lineHeight;
      state.textColor = textColor;
      state.selectedTensakuText.font_size = state.fontSize;
      state.selectedTensakuText.line_height = state.lineHeight;
      state.selectedTensakuText.color = state.textColor;
      const size = Common.getTextSize(state.selectedTensakuText.text, state.fontSize, state.lineHeight);
      state.selectedTensakuText.width = size.width;
      state.selectedTensakuText.height = size.height;
      state.selectedTensakuText.base64_text = Common.createBase64Text(state.selectedTensakuText);
      state.fieldActivities[state.selectedIdx].isTextEdited = true;
    }

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 添削テキストスタンプ追加
     ************************************************************/

    const addTensakuText = (point: Point) => {
      const size = Common.getTextSize("", state.fontSize, state.lineHeight);
      const tensakuText = new TensakuText();
      tensakuText.text = ""
      tensakuText.field_activity_id = state.fieldActivities[state.selectedIdx].id;
      tensakuText.idx = state.fieldActivities[state.selectedIdx].tensakuTextIdx++;
      tensakuText.font_size = state.fontSize;
      tensakuText.line_height = 0;
      tensakuText.color = state.textColor;
      tensakuText.x = point.x;
      tensakuText.y = point.y;
      tensakuText.width = size.width;
      tensakuText.height = size.height;
      tensakuText.base64_text = Common.createBase64Text(tensakuText);
      state.fieldActivities[state.selectedIdx].tensakuTexts.push(tensakuText);
      state.selectedTensakuText = tensakuText;
    }

    /************************************************************
     * 横向きモードのスプリッターリサイズ
     ************************************************************/

    const horizonHeightPaneResizing = (e: ResizingEventArgs) => {
      console.log("resizing");
      state.horizonTopHeightPer = e.paneSize[0] / state.mainAreaHeight;
      state.horizonBottomHeightPer = e.paneSize[1] / state.mainAreaHeight;
      adjustLayout();
    }

    /************************************************************
     * 縦向きモードのスプリッターリサイズ
     ************************************************************/

    const verticalWidthPaneResizing = (e: ResizingEventArgs) => {
      state.verticalLeftWidthPer = e.paneSize[0] / state.mainAreaWidth;
      state.verticalRightWidthPer = e.paneSize[1] / state.mainAreaWidth;
      adjustLayout();
    }

    /************************************************************
     * 採点エリアwidth
     ************************************************************/

    const saitenBoxAreaWidth = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Horizon){
        return state.mainAreaWidth - state.scrollBarSize;
      }else{
        return state.mainAreaWidth * state.verticalRightWidthPer - state.scrollBarSize;
      }
    });

    /************************************************************
     * 採点エリアheight
     ************************************************************/

    const saitenBoxAreaHeight = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Vertical){
        return state.mainAreaHeight - state.scrollBarSize - state.correctImageMarginTop;
      }else{
        return state.mainAreaHeight * state.horizonBottomHeightPer - state.scrollBarSize - state.correctImageMarginTop
      }
    });

    /************************************************************
     * 模範解答エリアwidth
     ************************************************************/

    const correctImageAreaWidth = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Horizon){
        return state.mainAreaWidth - state.scrollBarSize;
      }else{
        return state.mainAreaWidth * state.verticalLeftWidthPer - state.scrollBarSize;
      }
    });

    /************************************************************
     * 模範解答エリアheight
     ************************************************************/

    const correctImageAreaHeight = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Vertical){
        return state.mainAreaHeight - state.scrollBarSize - state.correctImageMarginTop;
      }else{
        return state.mainAreaHeight * state.horizonTopHeightPer - state.scrollBarSize - state.correctImageMarginTop
      }
    });

    /************************************************************
     * 模範解答エリア倍率設定
     ************************************************************/

    const setCorrectImageScale = () => {
      const scaleW = (correctImageAreaWidth.value) / (state.currentSheetField.baseWidth);
      const scaleH = (correctImageAreaHeight.value) / (state.currentSheetField.baseHeight);
      state.correctImageScale = (scaleW > scaleH ? scaleH : scaleW) * 100;
    }

    /************************************************************
     * 画面レイアウト縦横モード切り替え
     ************************************************************/

    const changeDirection = (direction: number) => {
      if(state.direction != direction){
        state.direction = direction;
        adjustLayout();
        setCorrectImageScale();
      }
    }

    /************************************************************
     * 模範解答imgタグのCSS
     ************************************************************/

    const correctImageStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${state.currentSheetField.baseWidth * state.correctImageScale / 100}px`;
      style["height"] = `${state.currentSheetField.baseHeight * state.correctImageScale / 100}px`;
      style["margin-top"] = `15px`;
      style["padding-left"] = `8px`;
      style["padding-right"] = `8px`;
      style["padding-bottom"] = `8px`;
      return style;
    });

    /************************************************************
     * 採点内容編集可能か返却
     ************************************************************/

    const isEditable = computed((): any => {
      if(state.currentSheet.edit_lock && state.currentSheet.created_by != null && state.currentSheet.created_by != context.root.$store.state.currentUser.login_id && context.root.$store.state.currentUser.role == Common.RoleEnum.Teacher2){
        return false;
      }else{
        return true;
      }
    });

    /************************************************************
     * ショートカットキー使用可否判定
     ************************************************************/

    const isShortcutEditable = computed((): any => {
      return !state.isProcessingApi && !context.root.$store.state.isShowingMsgBox;
    });

    /************************************************************
     * ボタンからフォーカス解除
     ************************************************************/
    const blur = () => {
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
    }

    /************************************************************
     * 画面のレイアウト整形
     * 初期表示・ウィンドウリサイズ・拡大縮小ボタン押下時に発動
     ************************************************************/

    const adjustLayout = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const imageArea = document.getElementById("image-area");
      const footerArea = document.getElementById("footer-area");
      const footerBorder = document.getElementById("footer-border");
      state.windowHeight = windowHeight;
      
      // 画像表示エリアの高さを画面サイズに合わせる
      if(imageArea != null && footerArea != null){
        state.mainAreaHeight = windowHeight - imageArea.offsetTop - footerArea.clientHeight - footerBorder.offsetHeight;
        state.mainAreaWidth = windowWidth;
        imageArea.style.height = `${state.mainAreaHeight}px`;
      }
      
      // 画像1件あたりの縦横サイズを整形
      state.fieldWrapWidth = (saitenBoxAreaWidth.value - 20) / state.colCount - (state.fieldMargin * 2);
      state.fieldImageWidth = state.fieldWrapWidth - (state.fieldPadding * 2);
      state.scale = state.fieldImageWidth / (state.currentSheetField.baseWidth);
      state.fieldImageHeight = Math.round((state.currentSheetField.baseHeight) * state.scale);
      state.fieldWrapHeight = state.fieldImageHeight + state.fieldPadding * 2;

      setCorrectImageScale();
    };

    /************************************************************
     * 模範解答モーダル表示
     ************************************************************/

    const changeDispCorrectImage = () => {
      blur();
      state.isDispCorrectImage = !state.isDispCorrectImage;
      adjustLayout();
    };

    /************************************************************
     * メモモーダル表示
     ************************************************************/

    const showModalMemo = () => {
      blur();
      modalAddtionRef.value.show();
    };

    /************************************************************
     * PC用ヘルプモーダル表示
     ************************************************************/

    const showModalPcHelp = () => {
      blur();
      modalPcHelpRef.value.show();
    };

    /************************************************************
     * タブレット用ヘルプモーダル表示
     ************************************************************/

    const showModalTabletHelp = () => {
      blur();
      modalTabletHelpRef.value.show();
    };

    /************************************************************
     * 全体画像モーダル表示
     ************************************************************/

    const showPreviewImage = async (examineeId: number) => {
      blur();

      state.previewScanImageExamineeId = examineeId;
      state.isScanImageVisible = true;
    };

    /************************************************************
     * 並び順切り替え
     ************************************************************/

    const changeSortKind = (sortKind: number, isInitialize: boolean = false) => {
      blur();

      if(isInitialize){
        // 初期表示のソートは昇順にする
        state.isSortAsc = true;
      }else if(state.sortKind == sortKind){
        // 現在設定されているソートと同じボタン押下の場合は昇順・降順を切り替え
        state.isSortAsc = !state.isSortAsc;
      }

      state.sortKind = sortKind;
      
      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });

      if (sortKind == state.SortKindEnum.No) {
        state.fieldActivities.sort((a, b) => {
          if (state.isSortAsc) {
            return a.sheetActivity.student_id - b.sheetActivity.student_id;
          } else {
            return b.sheetActivity.student_id - a.sheetActivity.student_id;
          }
        });
      } else if (sortKind == state.SortKindEnum.CorrectState) {
        state.fieldActivities.sort((a, b) => {
          if (a.score != b.score) {
            if (state.isSortAsc) {
              return b.score - a.score;
            } else {
              return a.score - b.score;
            }
          } else {
            if (state.isSortAsc) {
              return a.sheetActivity.student_id - b.sheetActivity.student_id;
            } else {
              return b.sheetActivity.student_id - a.sheetActivity.student_id;
            }
          }
        });
      } else {
        state.fieldActivities.sort((a, b) => {
          if (a.base64Image.length != b.base64Image.length) {
            if (state.isSortAsc) {
              return a.base64Image.length - b.base64Image.length;
            } else {
              return b.base64Image.length - a.base64Image.length;
            }
          } else {
            if (state.isSortAsc) {
              return a.sheetActivity.student_id - b.sheetActivity.student_id;
            } else {
              return b.sheetActivity.student_id - a.sheetActivity.student_id;
            }
          }
        });
      }

      state.examineeIds = state.fieldActivities.map(x => x.examinee.id);
    };

    /************************************************************
     * 拡大・縮小
     ************************************************************/

    const changeColCount = (addValue: number) => {
      blur();
      if(state.colCount + addValue <= 0){
        return;
      }

      state.colCount += addValue;
      state.isColCountChanged = true;
      adjustLayout();
    }

    /************************************************************
     * 採点モード切り替え
     ************************************************************/

    const changeSaitenMode = (saitenMode: number) => {
      blur();
      if(state.saitenMode == saitenMode){
        state.saitenMode = state.SaitenModeEnum.None;
      }else{
        state.saitenMode = saitenMode;
      }
      changeSelectedTensakuText(null);
    }

    /************************************************************
     * 採点BOXからのemitによる採点モード切り替え
     ************************************************************/

    const changeSaitenModeBySaitenBox = (saitenMode: number) => {
      state.saitenMode = saitenMode;
    }

    /************************************************************
     * キー押下
     ************************************************************/

    const keyUp = (e:KeyboardEvent) => {
      state.keyCode = "";

      if(e.key == "e" || e.key == "d"){
        // 現在描画中のcanvasを保持
        saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
          if(x.idx == state.selectedIdx){
            x.resetDrawingByKeyUp();
          }
        });
      }
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

    const keyDown = async (e: KeyboardEvent) => {

      if(e.key == "e" || e.key == "d" || e.key == "e" || e.key == "d" || e.key == "t"){
        state.keyCode = e.key;
      }

      // API通信中は処理しない
      if(!isShortcutEditable.value){
        return;
      }

      // textareaがフォーカスされている場合は処理しない
      if(document.activeElement.nodeName.toLowerCase() == "textarea"){
        return;
      }

      e.preventDefault();

      if(["o", "a", "x", "f", "y", "1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(e.key) != -1){
        
        // キー入力モード以外は処理しない
        if(state.saitenMode != state.SaitenModeEnum.KeyInput){
          return;
        }

        if(e.key == "o" || e.key == "a"){
          // Oキー Aキー 正答
          setCorrect(state.CorrectStateEnum.Seitou, state.currentSheetField.allot);
        }else if(e.key == "x" || e.key == "f"){
          // Xキー Fキー 誤答
          setCorrect(state.CorrectStateEnum.Gotou, 0);
        }else if(e.key == "y"){
          // Yキー 部分点 部分点入力不可の場合は処理終了
          if(state.isTokutenModeDisabled){
            return;
          }
          setCorrect(state.CorrectStateEnum.Tokuten, state.selectedScore);
        }else if(["1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(e.key) != -1){
          // 数字キー1〜9押下で部分点
          const score = Number(e.key);
          if(score < state.currentSheetField.allot){
            setCorrect(state.CorrectStateEnum.Tokuten, score);
          }else{
            // 部分点が配点の範囲外の場合は処理終了
            return;
          }
        }

        if(state.selectedIdx + 1 == state.fieldActivities.length){
          if(state.fieldActivities.filter(x => x.correct_state == null).length == 0){
            setTimeout(async () => {
              // 次の設問 又は 次の教室へ
              if(context.root.$store.getters.isEntranceOrPractice){
                if(state.next_room_sheet_field != null){          
                  toNextSheet();
                }else if(await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("一覧へ移動します。よろしいですか？"))){
                  sendSaitenData(null, null);
                }
              }else{
                if(state.next_sheet_field != null){          
                  toNextField();
                }else if(await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("最後の設問を採点しました。一覧へ移動します。よろしいですか？"))){
                  sendSaitenData(null, null);
                }
              }
            }, 100);
          }
        }else{
          state.selectedIdx++;
          const prevSaitenBox = document.getElementById(`saiten-box-${state.selectedIdx - 1}-${state.direction}`);
          const nextSaitenBox = document.getElementById(`saiten-box-${state.selectedIdx}-${state.direction}`);
          if(prevSaitenBox.offsetTop != nextSaitenBox.offsetTop){
            const imageArea = document.getElementById("saiten-box-area");
            const fromPos = imageArea.scrollTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop);
            const toPos = nextSaitenBox.offsetTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop) - imageArea.offsetTop;
            Common.smoothScroll(fromPos, toPos, 0, 0, imageArea);
          }
        }
      }else if(e.key == "Enter"){
        // エンターキー モーダル用時中の場合はモーダルを閉じる それ以外は後続処理で次の設問へ画面遷移
        if(modalAddtionRef.value.$data.isShow){
          modalAddtionRef.value.hide();
        }else{
          // 次の設問 又は 次の教室へ
          if(context.root.$store.getters.isEntranceOrPractice){
            if(state.next_room_sheet_field != null){          
              toNextSheet();
            }else if(await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("一覧へ移動します。よろしいですか？"))){
              sendSaitenData(null, null);
            }
          }else{
            if(state.next_sheet_field != null){          
              await toNextField();
            }else if(await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("最後の設問を採点しました。一覧へ移動します。よろしいですか？"))){
              sendSaitenData(null, null);
            }
          }
        }
      }else if(["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].indexOf(e.key) != -1){
        
        const nowIdx = state.selectedIdx;
        let nextIdx = -1;

        if(e.key == "ArrowLeft"){
          // 左矢印 前の設問へ
          nextIdx = state.selectedIdx - 1;
        }else if(e.key == "ArrowRight"){
          // 右矢印 次の設問へ
          nextIdx =  state.selectedIdx + 1;
        }else{
          const row = Math.floor(state.selectedIdx / state.colCount);
          const col = state.selectedIdx % state.colCount;
          if(e.key == "ArrowUp"){
            // 上矢印 上の行の設問へ
            nextIdx = ((row - 1) * state.colCount) + col;
          }else if(e.key == "ArrowDown"){
            // 下矢印 下の行の設問へ
            nextIdx = ((row + 1) * state.colCount) + col;
          }
        }

        // インデックスが範囲外の場合は処理終了
        if(nextIdx < 0 || nextIdx + 1 > state.fieldActivities.length){
          return;
        }

        state.selectedIdx = nextIdx;
        changeSelectedTensakuText(null);
        const nowSaitenBox = document.getElementById(`saiten-box-${nowIdx}-${state.direction}`);
        const nextSaitenBox = document.getElementById(`saiten-box-${nextIdx}-${state.direction}`);
        if(nowSaitenBox.offsetTop != nextSaitenBox.offsetTop){
          const imageArea = document.getElementById("saiten-box-area");
          const fromPos = imageArea.scrollTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop);
          const toPos = nextSaitenBox.offsetTop - parseInt(window.getComputedStyle(nextSaitenBox).marginTop) - imageArea.offsetTop;
          Common.smoothScroll(fromPos, toPos, 0, 0, imageArea);
        }

      }else if(e.key == "w"){
        // Wキー 模範解答の表示・非表示切り替え
        state.isDispCorrectImage = !state.isDispCorrectImage;
        context.root.$nextTick(() => {
          adjustLayout();
        });
      }else if(e.key == "p"){
        // Pキー 一括正答採点
        allCorrectChange(CorrectStateEnum.Seitou);
      }else if(e.key == "z"){
        // Zキー 一括誤答採点
        allCorrectChange(CorrectStateEnum.Gotou);
      }else if(e.key == "n"){
        if(state.next_room_sheet_field != null){          
          toNextSheet();
        }
      }else if(e.key == "m"){
        if(state.next_sheet_field != null){          
          toNextField();
        }
      }else if(e.key == "Backspace"){
        if(state.selectedTensakuText){
          const idx = state.fieldActivities[state.selectedIdx].tensakuTexts.indexOf(state.selectedTensakuText);
          deleteTensakuText(state.selectedIdx, idx);
          state.fieldActivities[state.selectedIdx].isTextEdited = true;
        }else{
          if(context.root.$store.getters.isEntranceOrPractice && state.currentSheet.approval_flg){
            await Common.customAlert(context.root.$bvModal, context.root.$store, `承認済みの試験のため、採点内容の変更はできません。`);
            return;
          }
          const fieldActivity = state.fieldActivities[state.selectedIdx];
          fieldActivity.correct_state = null;
          fieldActivity.score = null;
          // 選択中の切り出しのcanvasをクリア
          saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
            if(x.idx == state.selectedIdx){
              x.clearCanvas();
            }
          });
        }
      }else if(e.key == "q"){
        // Qキー 縮小
        changeColCount(1);
      }else if(e.key == "g"){
        // Gキー 拡大
        changeColCount(-1);
      }else if(e.key == "h"){
        // Hキー 保存して戻る
        toSaitenListWithSendSaitenData();
      }
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 得点スタンプ削除
     ************************************************************/

    const deleteTensakuText = (fieldActivityIdx: number, tensakuTextIdx: number) => {
      state.fieldActivities[fieldActivityIdx].tensakuTexts.splice(tensakuTextIdx, 1);
      state.selectedTensakuText = null;
    }

    /************************************************************
     * 採点内容変更
     ************************************************************/

    const setCorrect = (correctState: number, score: number) => {

      const fieldActivity = state.fieldActivities[state.selectedIdx];
      fieldActivity.correct_state = correctState;
      fieldActivity.score = score;

      if(context.root.$store.getters.isEntranceOrPractice && !isFirstScoring()){
        const isCorrectChanged = fieldActivity.correct_state != fieldActivity.correct_state_cache || fieldActivity.score != fieldActivity.score_cache ? true : fieldActivity.is_correct_changed_cache;
        fieldActivity.is_correct_changed = isCorrectChanged;
      }
    }

    /************************************************************
     * 一括採点ボタン押下
     ************************************************************/

    const allCorrectChange = async (correctState: number) => {

      blur();

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "未採点項目の採点内容を一括で変更します。よろしいですか？")){
        return;
      }

      state.fieldActivities.filter(x => x.correct_state == null).forEach(x => {
        x.correct_state = correctState;
        if(correctState == state.CorrectStateEnum.Seitou){
          x.score = state.currentSheetField.allot;
        }else{ 
          x.score = 0;
        }
      });
    };

    /************************************************************
     * CLEARボタン押下
     ************************************************************/

    const clearCorrectAll = async () => {
      blur();

      if(context.root.$store.getters.isEntranceOrPractice && state.currentSheet.approval_flg){
        await Common.customAlert(context.root.$bvModal, context.root.$store, `承認済みの試験のため、採点内容の変更はできません。`);
        return;
      }

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "画面に表示されている採点内容のデータを削除します。よろしいですか？")){
        return;
      }

      // パラメータ用FieldActivities
      const paramFieldActivities = new Array<ParamFieldActivity>();
      state.fieldActivities.forEach(x => {
        paramFieldActivities.push(new ParamFieldActivity(x));
      });

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/saiten_input/clear_correct/${state.sheet_field_id}`, {field_activities: JSON.stringify(paramFieldActivities)}).then(async response => {
        await Common.customAlert(context.root.$bvModal, context.root.$store, `採点内容のクリアに成功しました。`);
        window.location.reload();
      })
      .catch(async error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 採点一覧へ遷移
     ************************************************************/

    const toSaitenList = async (isDispSaveConfirm: boolean = false) => {
      if(isDispSaveConfirm && !await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("採点結果は保存されません。よろしいですか？"))){
        return;
      }
      context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
    };

    /************************************************************
     * 保存して採点一覧へ遷移
     ************************************************************/

    const toSaitenListWithSendSaitenData = async () => {
      blur();

      if(!isEditable.value){
        await Common.customAlert(context.root.$bvModal, context.root.$store, "この試験は作成者・管理者以外は保存できません。");
        return;
      }

      if(!await checkSavable() || !await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("採点内容を保存して採点一覧に戻ります。よろしいですか？"))){
        return;
      }

      sendSaitenData(null, null);
    };

    /************************************************************
     * 前の設問へ遷移
     ************************************************************/

    const toPrevField = async () => {
      blur();
      if(isEditable.value){
        if(!await checkSavable() || !await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("前の設問へ移動します。よろしいですか？"))){
          return;
        }
        sendSaitenData(Number(state.sheet_id), state.prev_sheet_field);
      }else{
        if(!await checkSavable() || !await Common.customConfirm(context.root.$bvModal, context.root.$store, "この試験は作成者・管理者以外は保存できません。保存せず前の設問へ移動します。よろしいですか？")){
          return;
        }
        changeFieldWithResetLastScored(Number(state.sheet_id), state.prev_sheet_field);
      }
    };

    /************************************************************
     * 次の設問へ遷移
     ************************************************************/

    const toNextField = async () => {
      blur();

      if(isEditable.value){
        if(!await checkSavable() || !await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("次の設問へ移動します。よろしいですか？"))){
          return;
        }
        await sendSaitenData(Number(state.sheet_id), state.next_sheet_field);
      }else{
        if(!await checkSavable() || !await Common.customConfirm(context.root.$bvModal, context.root.$store, "この試験は作成者・管理者以外は保存できません。保存せず次の設問へ移動します。よろしいですか？")){
          return;
        }
        await changeFieldWithResetLastScored(Number(state.sheet_id), state.next_sheet_field);
      }
      
    };

    /************************************************************
     * 次の教室へ遷移
     ************************************************************/

    const toNextSheet = async () => {
      blur();

      if(isEditable.value){
        const msg = state.is_last_room ? "先頭の教室に戻ります。よろしいですか？" : "次の教室へ移動します。よろしいですか？";
        if(!await checkSavable() || !await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage(msg))){
          return;
        }
        sendSaitenData(state.next_room_sheet_id, state.next_room_sheet_field);
      }else{
        if(!await checkSavable() || !await Common.customConfirm(context.root.$bvModal, context.root.$store, "この試験は作成者・管理者以外は保存できません。保存せず次の教室へ移動します。よろしいですか？")){
          return;
        }
        changeFieldWithResetLastScored(state.next_room_sheet_id, state.next_room_sheet_field);
      }
    };

    /************************************************************
     * 前の教室へ遷移
     ************************************************************/

    const toPrevSheet = async () => {
      blur();

      if(isEditable.value){
        if(!await checkSavable() || !await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("前の教室へ移動します。よろしいですか？"))){
          return;
        }
        sendSaitenData(state.prev_room_sheet_id, state.prev_room_sheet_field);
      }else{
        if(!await checkSavable() || !await Common.customConfirm(context.root.$bvModal, context.root.$store, "この試験は作成者・管理者以外は保存できません。保存せず前の教室へ移動します。よろしいですか？")){
          return;
        }
        changeFieldWithResetLastScored(state.prev_room_sheet_id, state.prev_room_sheet_field);
      }
    };

    /************************************************************
     * 保存処理可能か判定
     ************************************************************/

    const checkSavable = async () => {
      if(context.root.$store.getters.isEntranceOrPractice && isFirstScoring() && state.fieldActivities.filter(x => x.correct_state == null).length > 0){
        await Common.customAlert(context.root.$bvModal, context.root.$store, `2次採点以降で未採点がある場合、登録できません。採点を完了してください。`);
        return false;
      }else if(state.currentSheet.approval_flg && isExistsCorrectChangedField()){
        await Common.customAlert(context.root.$bvModal, context.root.$store, `承認済みの試験のため、採点内容の変更はできません。`);
        return false;
      }else{
        return true;
      }
    };

    /************************************************************
     * メモ更新API
     ************************************************************/

    const updateAddition = async () => {
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "メモを更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/saiten_input/update_addition/${state.sheet_field_id}`, {addition: state.currentSheetField.addition}).then(async response => {
        modalAddtionRef.value.hide();
      })
      .catch(async error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 2次採点以降の採点内容変更判定
     * 入試・模試の2次採点以降で採点内容変更の場合true, それ以外はfalse
     ************************************************************/

    const isExistsCorrectChangedField = () => {
      const correctUpdatedIds = state.fieldActivities.filter(x => x.correct_state != x.correct_state_cache || x.score != x.score_cache).map(x => x.id);
      const canvasUpdatedIds = state.fieldActivities.filter(x => x.isCanvasEdited).map(x => x.id);
      return context.root.$store.getters.isEntranceOrPractice && !isFirstScoring() && (correctUpdatedIds.length > 0 || canvasUpdatedIds.length > 0);
    }

    /************************************************************
     * 登録前の確認メッセージ取得
     * 入試・模試で2次採点以降の採点内容変更の場合は固定の文言、それ以外は各操作のデフォルト文言
     ************************************************************/

    const getConfirmMessage = (defaultMessage: string) => {
      if(context.root.$store.getters.isEntranceOrPractice && isExistsCorrectChangedField()){
        return "採点内容を変更しました。よろしいですか？";
      }else{
        return defaultMessage;
      }
    }

    /************************************************************
     * 1次採点か判定
     ************************************************************/
    const isFirstScoring = () => {
      
      if(state.currentSheet.verify_count == 2){
        if(state.currentSheetField.first_scorers_id && state.currentSheetField.second_scorers_id){
          // 2次採点まで完了している
          return false
        }else if(state.currentSheetField.first_scorers_id && !state.currentSheetField.second_scorers_id
          && state.currentSheetField.first_scorers_id != context.root.$store.state.currentUser.id){
          // 1次採点完了、2次採点中
          return false;
        }else{
          return true;
        }
      }else if(state.currentSheet.verify_count == 3){
        if(state.currentSheetField.first_scorers_id && state.currentSheetField.second_scorers_id && state.currentSheetField.third_scorers_id){
          // 3次採点まで完了している
          return false;
        }else if(!state.currentSheetField.third_scorers_id && state.currentSheetField.second_scorers_id && state.currentSheetField.first_scorers_id){
          // 2次採点まで完了している
          return false;
        }else if(!state.currentSheetField.second_scorers_id && state.currentSheetField.first_scorers_id && state.currentSheetField.first_scorers_id != context.root.$store.state.currentUser.id){
          // 1次採点完了、2次採点中
          return false;
        }else{
          return true;
        }
      }
    }

    /************************************************************
     * 採点データ保存API
     ************************************************************/

    const sendSaitenData = async (next_sheet_id: number, next_sheet_field: SheetField) => {

      context.root.$store.dispatch("showOverlay");
      state.isProcessingApi = true;

      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });
      
      // 添削画像をZip化
      let zip = new jsZip();
      state.fieldActivities.forEach(x => {
        if(x.isCanvasEdited){
          zip.file(`${x.id}.png`, x.base64Canvas, {base64: true});
        }
        if(x.isTextEdited){
          x.tensakuTexts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
            zip.file(`tensaku_text_${y.field_activity_id}_${y.idx}.png`, y.base64_text, {base64: true});
          });
        }
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        // パラメータ用FieldActivities
        const paramFieldActivities = new Array<ParamFieldActivity>();
        state.fieldActivities.forEach(x => {
          paramFieldActivities.push(new ParamFieldActivity(x));
        });

        // 採点内容 or Canvasに変更が生じたsheet_acrivity_id
        const correctUpdatedIds = state.fieldActivities.filter(x => x.correct_state != x.correct_state_cache || x.score != x.score_cache).map(x => x.id);
        const canvasUpdatedIds = state.fieldActivities.filter(x => x.isCanvasEdited).map(x => x.id);
        const tensakuUpdatedIds = state.fieldActivities.filter(x => x.isTextEdited).map(x => x.id);

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("field_activities", JSON.stringify(paramFieldActivities));
        fd.append("processing_time", `${state.processingTime}`);
        fd.append("sheet_field_id", state.sheet_field_id);
        fd.append("scoring_type", `${state.currentSheetField.scoring_type}`);
        fd.append("correct_updated_ids", JSON.stringify(correctUpdatedIds));
        fd.append("canvas_updated_ids", JSON.stringify(canvasUpdatedIds));
        fd.append("tensaku_updated_ids", JSON.stringify(tensakuUpdatedIds));

        await http.post(`/api/teacher/saiten_input/update/${state.sheet_id}`, fd).then(async response => {
          if(next_sheet_id != null){
            if(next_sheet_field.scoring_type == Common.ScoringTypeEnum.Seigo){
              // 正誤採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input/${next_sheet_id}/${next_sheet_field.id}`
              context.root.$router.push(toUrl).catch(err => {});
              context.root.$nextTick(() => {
                state.isLoaded = false;
                initialize();
              });
            }else{
              // 得点スタンプ採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input_score_stamp/${next_sheet_id}/${next_sheet_field.id}`
              context.root.$router.push(toUrl).catch(err => {});
            }
          }else{
            // 採点一覧へ戻る
            context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
          }
        })
        .catch(async error=>{
          context.root.$store.dispatch("hideOverlay");
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });
    };

    /************************************************************
     * 排他制御解除して別設問へ移動するAPI
     ************************************************************/
    const changeFieldWithResetLastScored = async (next_sheet_id: number, next_sheet_field: SheetField) => {

      context.root.$store.dispatch("showOverlay");
      state.isProcessingApi = true;

      await http.post(`/api/teacher/saiten_input/reset_last_scored/${state.sheet_field_id}`).then(async response => {
        if(next_sheet_id != null){
          if(next_sheet_field.scoring_type == Common.ScoringTypeEnum.Seigo){
            // 正誤採点画面へ遷移
            const toUrl = `/teacher_site/saiten_input/${next_sheet_id}/${next_sheet_field.id}`
            context.root.$router.push(toUrl).catch(err => {});
            context.root.$nextTick(() => {
              state.isLoaded = false;
              initialize();
            });
          }else{
            // 得点スタンプ採点画面へ遷移
            const toUrl = `/teacher_site/saiten_input_score_stamp/${next_sheet_id}/${next_sheet_field.id}`
            context.root.$router.push(toUrl).catch(err => {});
          }
        }else{
          // 採点一覧へ戻る
          context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
        }
      })
      .catch(async error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * 初期表示データ取得API
     ************************************************************/

    const initialize = async (isMounted: boolean = false) => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      state.sheet_field_id = context.root.$route.params.sheet_field_id;

      if(state.timer != null){
        clearInterval(state.timer);
      }

      let confirmMessage = null;
      let browsableSheetErrMessage = null;
      await http.get(`/api/teacher/saiten_input/check_saiten_lock/${state.sheet_field_id}`).then(async response => {
        confirmMessage = response.data.confirm_message;
        browsableSheetErrMessage = response.data.browse_lock_err_message;
      })
      .catch(async error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      if (browsableSheetErrMessage != null) {
        await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${browsableSheetErrMessage}`);
        context.root.$router.push(`/teacher_site/sheet_list/`).catch(err => {});
        return;
      }

      // 他者排他制御中の場合は確認メッセージ
      if(confirmMessage != null){
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, confirmMessage)){
          state.allowResetSaitenLock = false;
          toSaitenList();
          return;
        }
      }

      await http.get(`/api/teacher/saiten_input?sheet_id=${state.sheet_id}&sheet_field_id=${state.sheet_field_id}`).then(async response => {

        browsableSheetErrMessage = response.data.browse_lock_err_message;
        if (browsableSheetErrMessage != null) {
          return;
        }

        state.currentSheet = new Sheet(response.data.current_sheet);
        state.currentSheetField = new SheetField(response.data.current_sheet_field, response.data.buff_size);        
        state.fieldActivities = response.data.field_activities.map((x: any) => new FieldActivity(x, response.data.sheet_activities, response.data.examinees, response.data.base64_image_hash_array, response.data.base64_canvas_hash_array, state.currentSheet.page_count, response.data.tensaku_texts));
        state.base64CorrectImage = response.data.base64_correct_image;
        state.next_room_sheet_id = response.data.next_room_sheet_id;
        state.next_room_sheet_field = response.data.next_room_sheet_field ? new SheetField(response.data.next_room_sheet_field, response.data.buff_size) : null;
        state.prev_room_sheet_id = response.data.prev_room_sheet_id;
        state.prev_room_sheet_field = response.data.prev_room_sheet_field ? new SheetField(response.data.prev_room_sheet_field, response.data.buff_size) : null;
        state.prev_sheet_field = response.data.prev_sheet_field ? new SheetField(response.data.prev_sheet_field, response.data.buff_size) : null;
        state.next_sheet_field = response.data.next_sheet_field ? new SheetField(response.data.next_sheet_field, response.data.buff_size) : null;
        state.is_first_room = response.data.is_first_room;
        state.is_last_room = response.data.is_last_room;
        state.selectedIdx = 0;
        state.processingTime = 0;

        // 部分点プルダウン生成
        state.scoreOptions = new Array<any>();
        for(let i = 1; i < state.currentSheetField.allot; i++){
          state.scoreOptions.push({value: i, text: `${i}点`});
        }

        // 部分点プルダウン初期選択値設定
        if(state.scoreOptions.length > 0){
          state.selectedScore = state.scoreOptions[0].value;
          state.isTokutenModeDisabled = false;
        }else{
          // 部分点選択不可の場合はボタン・プルダウン非活性
          state.isTokutenModeDisabled = true;
          if(state.saitenMode == state.SaitenModeEnum.TokutenClick){
            state.saitenMode = state.SaitenModeEnum.KeyInput;
          }
        }

        // １行あたりの画像表示数設定 横長：6画像 縦長：15画像
        if(!state.isColCountChanged){
          if(state.currentSheetField.baseWidth > state.currentSheetField.baseHeight){
            state.colCount = 6;
          }else{
            state.colCount = 15;
          }
        }

        state.examineeIds = state.fieldActivities.map(x => x.examinee.id);
      })
      .catch(async error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      if (browsableSheetErrMessage != null) {
        await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${browsableSheetErrMessage}`);
        context.root.$router.push(`/teacher_site/sheet_list/`).catch(err => {});
        return;
      }

      if(!state.isWindowEventAdded){
        window.addEventListener("keydown", keyDown);
        window.addEventListener("keyup", keyUp);
        window.addEventListener("resize", adjustLayout);
      }

      if(isMounted){
        state.direction = state.currentSheetField.baseWidth > state.currentSheetField.baseHeight ? DirectionEnum.Horizon : DirectionEnum.Vertical;
      }

      state.isLoaded = true;
      adjustLayout();
      context.root.$nextTick(() => {
        const verticalSaitenBoxAreaWidth = state.mainAreaWidth - state.separatorSize - (state.mainAreaWidth * state.verticalLeftWidthPer);
        state.verticalRightWidthPer = verticalSaitenBoxAreaWidth / state.mainAreaWidth;
        const horizonSaitenBoxAreaHeight = state.mainAreaHeight - state.separatorSize - (state.mainAreaHeight * state.horizonTopHeightPer);
        state.horizonBottomHeightPer = horizonSaitenBoxAreaHeight / state.mainAreaHeight;
        const saitenBoxArea = document.getElementById("saiten-box-area");
        state.scrollBarSize = saitenBoxArea.offsetWidth - saitenBoxArea.clientWidth;
        setCorrectImageScale();
      });
      state.processingTime = 0;
      state.timer = setInterval(() => state.processingTime++, 1000);

      context.root.$nextTick(() => {
        if(state.fieldActivities.filter(x => x.correct_state != null).length > 0){
          // 採点済みデータありの場合は○×順表示で表示
          changeSortKind(state.SortKindEnum.CorrectState, true);
        }else{
          // 全件未採点の場合は番号順で表示
          changeSortKind(state.SortKindEnum.No, true);
        }
      });

      const imageArea: HTMLElement = document.getElementById("image-area");
      imageArea.scrollTop = 0;

      state.isProcessingApi = false;
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 切り出し画像Base64文字列をセット
     ************************************************************/

    const setBase64Image = (idx: number, base64Image: string) => {
      state.fieldActivities[idx].base64Image = base64Image;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 添削画像Base64文字列をセット
     ************************************************************/

    const setBase64Canvas = (idx: number, base64Canvas: string) => {
      state.fieldActivities[idx].base64Canvas = base64Canvas;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * canvas編集フラグをセット
     ************************************************************/

    const setCanvasEdited = (idx: number) => {
      state.fieldActivities[idx].isCanvasEdited = true;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 設問の画像上をクリック
     ************************************************************/

    const fieldClicked = async (idx: number, clickedTensakuText: TensakuText) => {
      state.selectedIdx = idx;
      changeSelectedTensakuText(clickedTensakuText);
      
      if(state.saitenMode == state.SaitenModeEnum.SeitouClick){
        setCorrect(state.CorrectStateEnum.Seitou, state.currentSheetField.allot);
      }else if(state.saitenMode == state.SaitenModeEnum.GotouClick){
        setCorrect(state.CorrectStateEnum.Gotou, 0);
      }else if(state.saitenMode == state.SaitenModeEnum.TokutenClick){
        setCorrect(state.CorrectStateEnum.Tokuten, state.selectedScore);
      }
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 設問の画像上フリックによる採点
     ************************************************************/
    
    const setCorrectByTouch = async (idx: number, correctState: number) => {
      state.selectedIdx = idx;
      changeSelectedTensakuText(null);
      
      if(correctState == state.CorrectStateEnum.Seitou){
        setCorrect(state.CorrectStateEnum.Seitou, state.currentSheetField.allot);
      }else if(correctState == state.CorrectStateEnum.Gotou){
        setCorrect(state.CorrectStateEnum.Gotou, 0);
      }else if(correctState == state.CorrectStateEnum.Tokuten && state.selectedScore > 0){
        setCorrect(state.CorrectStateEnum.Tokuten, state.selectedScore);
      }
    };

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);

      if(context.root.$store.state.isKaitouViewReloaded){
        context.root.$store.commit("setIsKaitouViewReloaded", false);
      }else{
        context.root.$store.commit("setIsKaitouViewReloaded", true);
        window.location.reload();
        return;
      }

      await initialize(true);
    });

    /************************************************************
     * before unmount windowイベント解除・排他制御解除
     ************************************************************/
    onBeforeUnmount(async () => {
      
      // タイマー停止
      if(state.timer != null){
        clearInterval(state.timer);
      }

      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("resize", adjustLayout);
      if(state.allowResetSaitenLock){
        await http.post(`/api/teacher/saiten_input/reset_last_scored/${state.sheet_field_id}`);
      }
    });

    return {
      ...toRefs(state),
      saitenBoxRef,
      modalAddtionRef,
      modalPcHelpRef,
      modalTabletHelpRef,
      previewImageSidebarRef,
      changeColCount,
      setBase64Image,
      fieldClicked,
      showPreviewImage,
      setCorrectByTouch,
      changeSaitenMode,
      changeSortKind,
      allCorrectChange,
      clearCorrectAll,
      setBase64Canvas,
      setCanvasEdited,
      focus,
      changeDispCorrectImage,
      showModalPcHelp,
      showModalTabletHelp,
      showModalMemo,
      toSaitenList,
      toPrevField,
      toNextField,
      toNextSheet,
      toPrevSheet,
      toSaitenListWithSendSaitenData,
      updateAddition,
      changeSaitenModeBySaitenBox,
      horizonHeightPaneResizing,
      verticalWidthPaneResizing,
      changeDirection,
      saitenBoxAreaHeight,
      saitenBoxAreaWidth,
      correctImageStyle,
      setCorrectImageScale,
      selectedTensakuTextElemId,
      addTensakuText,
      changeSelectedTensakuText,
      changeText,
      textFormatChanged,
      deleteTensakuText,
    };
  }
});
